<template>
  <app-wrapper>
    <transition appear name="fadeout">
      <v-layout column align-center justify-center class="mb-5">
        <v-alert outlined type="success" class="mt-4 mb-4" :value="true">
          <div class="title mt-2 mb-2">Password updated successfully.</div>
        </v-alert>
        <transition appear name="fadeout">
        <v-btn color="primary" dark large class="mb-5" @click="navSignIn()">Sign In</v-btn>
        </transition>
      </v-layout>
    </transition>
  </app-wrapper>
</template>

<script>
import wrapper from './wrapper'
import router from '../../routes'

export default {
  components: {
    'app-wrapper': wrapper
  },
  methods: {
    navSignIn: function () {
      // console.log('navigating to sign in')
      router.push('/signin')
    }
  },
  created () {
    this.$store.dispatch('changeShowToolbar', false)
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Auth/Changed.vue